import 'reflect-metadata';
import { Container } from 'inversify';
import { TYPES } from '@Types';
import {
  AnnoncementAction,
  ArmiesAction, ArmyAction,
  ArmyCategoriesAction,
  ArmyCategoryAction,
  ArmyListAction, ArmyListsAction,
  ArmyListUnitAction,
  ArmyListUnitOptionAction, ArmyListUnitUnitOptionAction, ArmyListUnitUnitOptionChangeProfilAction,
  ArsenalArmiesAction,
  ArsenalUnitAction, BookAction, BooksAction, CampaignsAction, ContestsAction,
  DraftAction,
  DraftTeamAction,
  FoldersAction,
  MatchAction, ModelRulesAction,
  MyArsenalAction,
  MyContestsAction,
  MyDrawAction,
  MyFolderAction, MyTeamsAction,
  OpponentDraftTeamAction,
  SyncAction, UserPreferenceAction, VersionsAction,
  ArmyBooksAction, ArmyBookAction
} from '@Redux/actions';
import { CacheManager } from '@Worker/CacheManager';
import { ApiClient, OpenAPI } from '@Api';
import { ArsenalArmyMapper } from '@Mapper/arsenal/arsenal-army.mapper';
import { ArsenalUnitMapper } from '@Mapper/arsenal/arsenal-unit.mapper';
import { VersionMapper } from '@Mapper/ninthAge/VersionMapper';
import { ArmyCategoryMapper } from '@Mapper/ninthAge/ArmyCategoryMapper';
import { ArmyMapper } from '@Mapper/ninthAge/ArmyMapper';
import { UnitTypeMapper } from '@Mapper/ninthAge/UnitTypeMapper';
import { UnitMapper } from '@Mapper/ninthAge/UnitMapper';
import { ModelRuleMapper } from '@Mapper/ninthAge/model-rule.mapper';
import { ModelRuleLimitMapper } from '@Mapper/ninthAge/ModelRuleLimitMapper';
import { MagicItemCategoryMapper } from '@Mapper/ninthAge/MagicItemCategoryMapper';
import { MagicItemMapper } from '@Mapper/ninthAge/magic-item.mapper';
import { MagicStandardMapper } from '@Mapper/ninthAge/magic-standard.mapper';
import { OrganisationMapper } from '@Mapper/ninthAge/OrganisationMapper';
import { ArmyOrganisationMapper } from '@Mapper/ninthAge/army-organisation.mapper';
import { ArmyOrganisationGroupMapper } from '@Mapper/ninthAge/army-organisation-group.mapper';
import { ModelRuleCategoryMapper } from '@Mapper/ninthAge/ModelRuleCategoryMapper';
import { UnitOptionMapper } from '@Mapper/ninthAge/unit-option.mapper';
import { ModelRuleUnitTroopMapper } from '@Mapper/ninthAge/ModelRuleUnitTroopMapper';
import { OrganisationChangeMapper } from '@Mapper/ninthAge/OrganisationChangeMapper';
import { OrganisationChangeAvailabilityMapper } from '@Mapper/ninthAge/OrganisationChangeAvailabilityMapper';
import { TroopMapper } from '@Mapper/ninthAge/TroopMapper';
import { UnitCaracMapper } from '@Mapper/ninthAge/UnitCaracMapper';
import { UnitOptionLimitMapper } from '@Mapper/ninthAge/UnitOptionLimitMapper';
import { UnitOptionAvailabilityMapper } from '@Mapper/ninthAge/UnitOptionAvailabilityMapper';
import { UnitOptionChangeProfilMapper } from '@Mapper/ninthAge/UnitOptionChangeProfilMapper';
import { UnitOptionChangeModelRuleMapper } from '@Mapper/ninthAge/UnitOptionChangeModelRuleMapper';
import { UnitOptionMagicItemCategoryMapper } from '@Mapper/ninthAge/UnitOptionMagicItemCategoryMapper';
import { UnitOptionUsePointMapper } from '@Mapper/ninthAge/UnitOptionUsePointMapper';
import { UnitOptionOrganisationModeMapper } from '@Mapper/ninthAge/UnitOptionOrganisationModeMapper';
import { VersionGameMapper } from '@Mapper/ninthAge/VersionGameMapper';
import { TroopCaracMapper } from '@Mapper/ninthAge/TroopCaracMapper';
import { TypeLvlMapper } from '@Mapper/ninthAge/TypeLvlMapper';
import { ArmyListMapper } from '@Mapper/builder/army-list.mapper';
import { ArmyListUnitMapper } from '@Mapper/builder/army-list-unit.mapper';
import { ArmyListUnitTroopMapper } from '@Mapper/builder/army-list-unit-troop.mapper';
import { ArmyListUnitUnitOptionMapper } from '@Mapper/builder/army-list-unit-unit-option.mapper';
import { FolderMapper } from '@Mapper/builder/folder.mapper';
import { ArmyListFormatedMapper } from '@Mapper/builder/import/army-list-formated.mapper';
import { ArmyListUnitFormatedMapper } from '@Mapper/builder/import/army-list-unit-formated.mapper';
import { ArmyListUnitOptionFormatedMapper } from '@Mapper/builder/import/army-list-unit-option-formated.mapper';
import { FormatErrorMapper } from '@Mapper/builder/import/format-error.mapper';
import { FormatErrorSeverityMapper } from '@Mapper/builder/import/format-error-severity.mapper';
import { ArmyListUnitModelRuleTroopMapper } from '@Mapper/builder/army-list-unit-model-rule-troop.mapper';
import { ContestMapper } from '@Mapper/tournament/ContestMapper';
import { TeamMapper } from '@Mapper/tournament/TeamMapper';
import { DraftMapper } from '@Mapper/tool/pairing/DraftMapper';
import { DraftTeamMapper } from '@Mapper/tool/pairing/DraftTeamMapper';
import { DrawMapper } from '@Mapper/tool/pairing/DrawMapper';
import { MatchMapper } from '@Mapper/tool/pairing/MatchMapper';
import { TeamArmyMapper } from '@Mapper/tool/pairing/TeamArmyMapper';
import { Locale } from '@Repository/locale';
import { ArsenalArmyRepository } from '@Repository/arsenal/ArsenalArmyRepository';
import { ArmyListUnitRepository } from '@Repository/builder/ArmyListUnitRepository';
import { VersionRepository } from '@Repository/ninthAge/VersionRepository';
import { ArmyListRepository } from '@Repository/builder/ArmyListRepository';
import { ArmyRepository } from '@Repository/ninthAge/ArmyRepository';
import { ArmyCategoryRepository } from '@Repository/ninthAge/ArmyCategoryRepository';
import { FolderRepository } from '@Repository/builder/FolderRespository';
import { SearchRepository } from '@Repository/builder/SearchRepository';
import { ModelRuleRepository } from '@Repository/ninthAge/ModelRuleRepository';
import { UnitRepository } from '@Repository/ninthAge/UnitRepository';
import { FormatRepository } from '@Repository/builder/FormatRepository';
import { ContestRepository } from '@Repository/tournament/ContestRepository';
import { MyContestRepository } from '@Repository/tournament/MyContestRepository';
import { MyTeamRepository } from '@Repository/tournament/MyTeamRepository';
import { DraftRepository } from '@Repository/tool/pairing/DraftRepository';
import { DraftTeamRepository } from '@Repository/tool/pairing/DraftTeamRepository';
import { DrawRepository } from '@Repository/tool/pairing/DrawRepository';
import { MatchRepository } from '@Repository/tool/pairing/MatchRepository';
import { MagicPathAction } from '@Redux/actions/ninthAge/MagicPathAction';
import { MagicPathRepository, MapRepository, UserFavoriteUnitRepository } from '@Repository/ninthAge';
import { MagicPathMapper } from '@Mapper/ninthAge/MagicPathMapper';
import { MagicSpellMapper } from '@Mapper/ninthAge/MagicSpellMapper';
import { ArsenalUnitRepository, ArsenalUnitStepRepository } from '@Repository/arsenal';
import { UnitCategoryMapper } from '@Mapper/ninthAge/UnitCategoryMapper';
import { UserPreferenceMapper } from '@Mapper/user/UserPreferenceMapper';
import { AnnoncementRepository, UserPreferenceRepository } from '@Repository/user';
import { AnnoncementMapper } from '@Mapper/user/AnnoncementMapper';
import { MapMapper } from '@Mapper/ninthAge/map.mapper';
import { MapsAction } from '@Redux/actions/ninthAge/MapsAction';
import { MapAction } from '@Redux/actions/ninthAge/map.action';
import { MyContestAction } from '@Redux/actions/tournament/MyContestAction';
import { SurveyAction } from '@Redux/actions/tool/survey/SurveyAction';
import { ModelRuleChangeProfilMapper } from '@Mapper/ninthAge/ModelRuleChangeProfilMapper';
import { ModelRuleChangeModelRuleMapper } from '@Mapper/ninthAge/ModelRuleChangeModelRuleMapper';
import { ArmyListUnitModelRuleTroopAction } from '@Redux/actions/builder/army-list-unit-model-rule-troop.action';
import { ArmyBookRepository, BookRepository } from '@Repository/publication';
import { BookMapper } from '@Mapper/publication/book.mapper';
import { BookSectionMapper } from '@Mapper/publication/book-section.mapper';
import { BookSectionAction } from '@Redux/actions/publication/book-section.action';
import { ClubMapper } from '@Mapper/federation/club.mapper';
import { CategoryRepository, ClubRepository, MyClubRepository } from '@Repository/federation';
import { ClubsAction } from '@Redux/actions/federation/clubs.action';
import { SpellDurationMapper } from '@Mapper/ninthAge/spell-duration.mapper';
import { SpellTypeMapper } from '@Mapper/ninthAge/spell-type.mapper';
import { UserBugReportMapper } from '@Mapper/user/user-bug-report.mapper';
import { UserBugReportRepository } from '@Repository/user/user-bug-report.repository';
import { UserBugReportAction } from '@Redux/actions/user/user-bug-report.action';
import { ArsenalStepMapper } from '@Mapper/arsenal/arsenal-step.mapper';
import { ArsenalUnitStepAction } from '@Redux/actions/arsenal/arsenal-unit-step.action';
import { MyClubsAction } from '@Redux/actions/federation/my-clubs.action';
import { FederationCategoryMapper } from '@Mapper/federation/federation-category.mapper';
import { CategoriesAction } from '@Redux/actions/federation/categories.action';
import { ConstraintMapper } from '@Mapper/ninthAge/constraint.mapper';
import { ConstraintModifierMapper } from '@Mapper/ninthAge/constraint-modifier.mapper';
import { PlayerMapper } from '@Mapper/federation/player.mapper';
import { PlayerRepository } from '@Repository/federation/player.repository';
import { PlayersAction } from '@Redux/actions/federation/players.action';
import { UserFavoriteUnitMapper } from '@Mapper/ninthAge/user-favorite/unit.mapper';
import { UserFavoriteUnitsAction } from '@Redux/actions/ninthAge/user-favorite-units.action';
import { ArmyBookMapper } from '@Mapper/publication/army-book.mapper';

const container = new Container({ skipBaseClassChecks: true });

container.bind(TYPES.Locale).to(Locale);

container.bind(TYPES.Actions.MyArsenalAction).to(MyArsenalAction);
container.bind(TYPES.Actions.ArsenalArmiesAction).to(ArsenalArmiesAction);
container.bind(TYPES.Actions.ArsenalUnitAction).to(ArsenalUnitAction);
container.bind(TYPES.Actions.ArsenalUnitStepAction).to(ArsenalUnitStepAction);
container.bind(TYPES.Repository.ArsenalArmyRepository).to(ArsenalArmyRepository);
container.bind(TYPES.Repository.ArsenalUnitRepository).to(ArsenalUnitRepository);
container.bind(TYPES.Repository.ArsenalUnitStepRepository).to(ArsenalUnitStepRepository);
container.bind(TYPES.Mapper.ArsenalArmyMapper).to(ArsenalArmyMapper);
container.bind(TYPES.Mapper.ArsenalUnitMapper).to(ArsenalUnitMapper);
container.bind(TYPES.Mapper.ArsenalStepMapper).to(ArsenalStepMapper);

container.bind(TYPES.Repository.ArmyListRepository).to(ArmyListRepository);
container.bind(TYPES.ArmyListUnitRepository).to(ArmyListUnitRepository);
container.bind(TYPES.Repository.VersionRepository).to(VersionRepository);
container.bind(TYPES.Repository.ArmyCategoryRepository).to(ArmyCategoryRepository);
container.bind(TYPES.Repository.ArmyRepository).to(ArmyRepository);
container.bind(TYPES.Repository.FolderRepository).to(FolderRepository);
container.bind(TYPES.Repository.SearchRepository).to(SearchRepository);
container.bind(TYPES.Repository.ModelRuleRepository).to(ModelRuleRepository);
container.bind(TYPES.Repository.UnitRepository).to(UnitRepository);
container.bind(TYPES.Repository.FormatRepository).to(FormatRepository);

container.bind(TYPES.Actions.FoldersAction).to(FoldersAction);
container.bind(TYPES.Actions.MyFolderAction).to(MyFolderAction);
container.bind(TYPES.Actions.ArmyListAction).to(ArmyListAction);
container.bind(TYPES.Actions.ArmyListUnitAction).to(ArmyListUnitAction);
container.bind(TYPES.Actions.ArmyListUnitOptionAction).to(ArmyListUnitOptionAction);
container.bind(TYPES.Actions.ArmyListUnitUnitOptionAction).to(ArmyListUnitUnitOptionAction);
container.bind(TYPES.Actions.ArmyListUnitUnitOptionChangeProfilAction).to(ArmyListUnitUnitOptionChangeProfilAction);

container.bind(TYPES.Mapper.VersionMapper).to(VersionMapper);
container.bind(TYPES.Actions.VersionsAction).to(VersionsAction);
container.bind(TYPES.Actions.ArmyAction).to(ArmyAction);
container.bind(TYPES.Actions.ArmyCategoriesAction).to(ArmyCategoriesAction);
container.bind(TYPES.Actions.ArmyCategoryAction).to(ArmyCategoryAction);
container.bind(TYPES.Actions.ArmiesAction).to(ArmiesAction);
container.bind(TYPES.Mapper.ArmyCategoryMapper).to(ArmyCategoryMapper);
container.bind(TYPES.Mapper.UnitCategoryMapper).to(UnitCategoryMapper);
container.bind(TYPES.Mapper.ArmyMapper).to(ArmyMapper);
container.bind(TYPES.UnitTypeMapper).to(UnitTypeMapper);
container.bind(TYPES.UnitMapper).to(UnitMapper);
container.bind(TYPES.Mapper.ModelRuleMapper).to(ModelRuleMapper);
container.bind(TYPES.Mapper.ModelRuleLimitMapper).to(ModelRuleLimitMapper);
container.bind(TYPES.MagicItemCategoryMapper).to(MagicItemCategoryMapper);
container.bind(TYPES.MagicItemMapper).to(MagicItemMapper);
container.bind(TYPES.MagicStandardMapper).to(MagicStandardMapper);
container.bind(TYPES.OrganisationMapper).to(OrganisationMapper);
container.bind(TYPES.ArmyOrganisationMapper).to(ArmyOrganisationMapper);
container.bind(TYPES.ArmyOrganisationGroupMapper).to(ArmyOrganisationGroupMapper);
container.bind(TYPES.Mapper.ModelRuleCategoryMapper).to(ModelRuleCategoryMapper);
container.bind(TYPES.UnitOptionMapper).to(UnitOptionMapper);
container.bind(TYPES.Mapper.ModelRuleUnitTroopMapper).to(ModelRuleUnitTroopMapper);
container.bind(TYPES.OrganisationChangeMapper).to(OrganisationChangeMapper);
container.bind(TYPES.Mapper.OrganisationChangeAvailabilityMapper).to(OrganisationChangeAvailabilityMapper);
container.bind(TYPES.TroopMapper).to(TroopMapper);
container.bind(TYPES.UnitCaracMapper).to(UnitCaracMapper);
container.bind(TYPES.UnitOptionLimitMapper).to(UnitOptionLimitMapper);
container.bind(TYPES.Mapper.UnitOptionAvailabilityMapper).to(UnitOptionAvailabilityMapper);
container.bind(TYPES.Mapper.UnitOptionChangeProfilMapper).to(UnitOptionChangeProfilMapper);
container.bind(TYPES.Mapper.UnitOptionChangeModelRuleMapper).to(UnitOptionChangeModelRuleMapper);
container.bind(TYPES.Mapper.UnitOptionMagicItemCategoryMapper).to(UnitOptionMagicItemCategoryMapper);
container.bind(TYPES.UnitOptionUsePointMapper).to(UnitOptionUsePointMapper);
container.bind(TYPES.Actions.ModelRulesAction).to(ModelRulesAction);
container.bind(TYPES.Mapper.UnitOptionOrganisationModeMapper).to(UnitOptionOrganisationModeMapper);
container.bind(TYPES.Mapper.VersionGameMapper).to(VersionGameMapper);
container.bind(TYPES.Mapper.TroopCaracMapper).to(TroopCaracMapper);
container.bind(TYPES.Mapper.TypeLvlMapper).to(TypeLvlMapper);
container.bind(TYPES.Actions.MagicPathAction).to(MagicPathAction);
container.bind(TYPES.Repository.MagicPathRepository).to(MagicPathRepository);
container.bind(TYPES.Mapper.MagicPathMapper).to(MagicPathMapper);
container.bind(TYPES.Mapper.MagicSpellMapper).to(MagicSpellMapper);
container.bind(TYPES.Mapper.MapMapper).to(MapMapper);
container.bind(TYPES.Repository.MapRepository).to(MapRepository);
container.bind(TYPES.Actions.MapsAction).to(MapsAction);
container.bind(TYPES.Actions.MapAction).to(MapAction);
container.bind(TYPES.Mapper.ModelRuleChangeProfilMapper).to(ModelRuleChangeProfilMapper);
container.bind(TYPES.Mapper.ModelRuleChangeModelRuleMapper).to(ModelRuleChangeModelRuleMapper);
container.bind(TYPES.Actions.ArmyListUnitModelRuleTroopAction).to(ArmyListUnitModelRuleTroopAction);
container.bind(TYPES.Mapper.SpellDurationMapper).to(SpellDurationMapper);
container.bind(TYPES.Mapper.SpellTypeMapper).to(SpellTypeMapper);
container.bind(TYPES.Mapper.ConstraintMapper).to(ConstraintMapper);
container.bind(TYPES.Mapper.ConstraintModifierMapper).to(ConstraintModifierMapper);
container.bind(TYPES.Mapper.UserFavorite.Unit).to(UserFavoriteUnitMapper);
container.bind(TYPES.Repository.UserFavorite.Unit).to(UserFavoriteUnitRepository);
container.bind(TYPES.Actions.NinthAge.FavoriteUnit.UserFavoriteUnitsAction).to(UserFavoriteUnitsAction)

container.bind(TYPES.ArmyListMapper).to(ArmyListMapper);
container.bind(TYPES.ArmyListUnitMapper).to(ArmyListUnitMapper);
container.bind(TYPES.Mapper.ArmyListUnitTroopMapper).to(ArmyListUnitTroopMapper);
container.bind(TYPES.ArmyListUnitUnitOptionMapper).to(ArmyListUnitUnitOptionMapper);
container.bind(TYPES.FolderMapper).to(FolderMapper);
container.bind(TYPES.Mapper.ArmyListFormatedMapper).to(ArmyListFormatedMapper);
container.bind(TYPES.Mapper.ArmyListUnitFormatedMapper).to(ArmyListUnitFormatedMapper);
container.bind(TYPES.Mapper.ArmyListUnitOptionFormatedMapper).to(ArmyListUnitOptionFormatedMapper);
container.bind(TYPES.Mapper.FormatErrorMapper).to(FormatErrorMapper);
container.bind(TYPES.Mapper.FormatErrorSeverityMapper).to(FormatErrorSeverityMapper);
container.bind(TYPES.Mapper.ArmyListUnitModelRuleTroopMapper).to(ArmyListUnitModelRuleTroopMapper);

container.bind(TYPES.Repository.ArmyBookRepository).to(ArmyBookRepository);
container.bind(TYPES.Repository.BookRepository).to(BookRepository);
container.bind(TYPES.Mapper.ArmyBookMapper).to(ArmyBookMapper);
container.bind(TYPES.Mapper.BookMapper).to(BookMapper);
container.bind(TYPES.Mapper.BookSectionMapper).to(BookSectionMapper);
container.bind(TYPES.Actions.Publication.ArmyBooksAction).to(ArmyBooksAction);
container.bind(TYPES.Actions.Publication.BooksAction).to(BooksAction);
container.bind(TYPES.Actions.Publication.ArmyBookAction).to(ArmyBookAction);
container.bind(TYPES.Actions.Publication.BookAction).to(BookAction);
container.bind(TYPES.Actions.Publication.BookSectionAction).to(BookSectionAction);

container.bind(TYPES.Repository.ContestRepository).to(ContestRepository);
container.bind(TYPES.Repository.MyContestRepository).to(MyContestRepository);
container.bind(TYPES.Repository.MyTeamRepository).to(MyTeamRepository);
container.bind(TYPES.Mapper.ContestMapper).to(ContestMapper);
container.bind(TYPES.Mapper.TeamMapper).to(TeamMapper);
container.bind(TYPES.Actions.ContestsAction).to(ContestsAction);
container.bind(TYPES.Actions.MyContestsAction).to(MyContestsAction);
container.bind(TYPES.Actions.MyContestAction).to(MyContestAction);
container.bind(TYPES.Actions.MyTeamsAction).to(MyTeamsAction);
container.bind(TYPES.Actions.ArmyListsAction).to(ArmyListsAction);


container.bind(TYPES.Mapper.DraftMapper).to(DraftMapper);
container.bind(TYPES.Repository.DraftRepository).to(DraftRepository);
container.bind(TYPES.Mapper.DraftTeamMapper).to(DraftTeamMapper);
container.bind(TYPES.Repository.DraftTeamRepository).to(DraftTeamRepository);
container.bind(TYPES.Mapper.DrawMapper).to(DrawMapper);
container.bind(TYPES.Repository.DrawRepository).to(DrawRepository);
container.bind(TYPES.Mapper.MatchMapper).to(MatchMapper);
container.bind(TYPES.Repository.MatchRepository).to(MatchRepository);
container.bind(TYPES.Mapper.TeamArmyMapper).to(TeamArmyMapper);
container.bind(TYPES.Actions.Tool.DraftAction).to(DraftAction);
container.bind(TYPES.Actions.Tool.DraftTeamAction).to(DraftTeamAction);
container.bind(TYPES.Actions.Tool.OpponentDraftTeamAction).to(OpponentDraftTeamAction);
container.bind(TYPES.Actions.Tool.MyDrawAction).to(MyDrawAction);
container.bind(TYPES.Actions.Tool.MatchAction).to(MatchAction);

container.bind(TYPES.Actions.Tool.Survey.SurveyAction).to(SurveyAction);
container.bind(TYPES.Actions.Tool.Survey.CampaignsAction).to(CampaignsAction);

container.bind(TYPES.Mapper.UserPreferenceMapper).to(UserPreferenceMapper);
container.bind(TYPES.Repository.UserPreferenceRepository).to(UserPreferenceRepository);
container.bind(TYPES.Actions.User.UserPreferenceAction).to(UserPreferenceAction);

container.bind(TYPES.Mapper.AnnoncementMapper).to(AnnoncementMapper);
container.bind(TYPES.Repository.AnnoncementRepository).to(AnnoncementRepository);
container.bind(TYPES.Actions.User.AnnoncementAction).to(AnnoncementAction);
container.bind(TYPES.Mapper.UserBugReportMapper).to(UserBugReportMapper);
container.bind(TYPES.Repository.UserBugReportRepository).to(UserBugReportRepository);
container.bind(TYPES.Actions.User.UserBugReportAction).to(UserBugReportAction);

container.bind(TYPES.Mapper.ClubMapper).to(ClubMapper);
container.bind(TYPES.Mapper.FederationCategoryMapper).to(FederationCategoryMapper);
container.bind(TYPES.Repository.ClubRepository).to(ClubRepository);
container.bind(TYPES.Repository.MyClubRepository).to(MyClubRepository);
container.bind(TYPES.Repository.CategoryRepository).to(CategoryRepository);
container.bind(TYPES.Actions.Federation.ClubsAction).to(ClubsAction);
container.bind(TYPES.Actions.Federation.MyClubsAction).to(MyClubsAction);
container.bind(TYPES.Actions.Federation.CategoriesAction).to(CategoriesAction);
container.bind(TYPES.Mapper.PlayerMapper).to(PlayerMapper);
container.bind(TYPES.Repository.PlayerRepository).to(PlayerRepository);
container.bind(TYPES.Actions.Federation.PlayersAction).to(PlayersAction);

container.bind(TYPES.Worker.CacheManager).to(CacheManager);
container.bind(TYPES.Actions.SyncAction).to(SyncAction);


container.bind(TYPES.Api.ApiClient).toDynamicValue(() => {
  const openAPI = OpenAPI;
  openAPI.BASE = '';
  return new ApiClient(openAPI);
});

export { container };
